import clsx from "clsx";
import styles from "./index.module.css";

const Checkmark = ({ className }: { className?: string }) => {
  return (
    <svg
      className={clsx(className, styles.icon)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 9.33333L7.5 12L11.5 4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Checkmark;
